import React from 'react';
import Pages from './basic_page';
class Collaborations extends Pages {
    render() {
        return (
    <>
            <h1 className='des_col'>
                Collaborations
            </h1>
        <div className='pageholder'>
            <div className='righttext'>
                <div className='P1' >
                    <div className='text_wrap'>
                    <p>We deeply agree that the spirit of cooperation is not only the key to enrich and improve our project, but also a core essence advocated by iGEM. Therefore, we always kept it in mind throughout the competition, carrying out multi-dimensional and in-depth cooperation with other teams.</p>  
                    </div>
                </div>

                <div className='P3' ref={this.secondRef}>
                    <div className='text_wrap'>
                    <h2>Wet Lab</h2>
                    <h3>Bluepha</h3>
                    <p>As a long-term partner, Bluepha has maintained intensive cooperation with Peking iGEM team for many years, and this year is no exception. They provided us with experimental skills training before the formal experiment. </p>
                    <div className='img_wrap'>
                        < img src="https://static.igem.wiki/teams/4298/wiki/colab-bluepha.png"  alt=" colab-bluepha" />
                    </div>
                    <h3>BNSC_China </h3>
                    <p>BNSC_China is a team composed of iGEM Chinese alumni, who set realizing the industrial application of the project as their goal. Since BNSC_China also adopted Orthorep and EvolvR, we obtained related plasmids from them. During the project, we discussed many issues on plasmid construction and transformation together, which played a significant role in promoting our project. </p>
                    <div className='img_wrap'>
                       
                    </div>
                    <h3>iBowu-China</h3>
                    <p>We got to know iBowu at the meetup and kept in close contact with them during the competition. We assisted them in measuring the induction effect of IPTG on the expression of target genes in different concentration gradients, and concluded that low concentration of IPTG could not induce the expression, then we fed back the results to iBowu. </p>
                    <div className='img_wrap'>
                    </div>
                    <h3>SHSBNU_China</h3>
                    <p>We got acquainted with SHSBNU at the meetup. It happened that we needed to verify whether E. coli with pTac-RJN-AcrB-mCh had stronger antibiotic resistance, and SHSBNU team had the corresponding experimental conditions. Therefore, we sent the bacteria to them. They repeated our experiment and concluded that the bacteria transferred by pTac-RJN-AcrB-mCh was not more antibiotic resistant than the empty bacteria, which was consistent with our results. </p>
                    <div className='img_wrap_icon_2'>
                        < img src="https://static.igem.wiki/teams/4298/wiki/colab-bnsc.jpg"  alt=" colab-bnsc"  />
                        < img src="https://static.igem.wiki/teams/4298/wiki/colab-ibowu.jpg"  alt="colab-ibowu" />
                        < img src="https://static.igem.wiki/teams/4298/wiki/colab-shsbnu.jpg"  alt="colab-shsbnu" />
                    </div>
                   
                    </div>
                </div>
            </div>
        </div>
    
    </>
    );
    }
};

export default Collaborations;
